import cn from 'classnames';
import { useCallback } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { Image } from '@/components/Image';
import { sendAnalytics } from '@/utils/analitycs';

import { SignUpRoute } from '../../../server/controllers/pages/signup/consts';

import headImg from './head-img.png';
import styles from './styles.module.scss';

export const HeadBlock = () => {
  const isMobile = useIsMobile();

  const onRegisterClick = useCallback(() => {
    sendAnalytics({
      eventAction: 'Лендинг|Мобильная версия',
      eventLabel: 'Зарегистрироваться',
    });
  }, []);

  return (
    <Space direction="vertical" size={16} className={isMobile ? 'h-pt-16 h-pb-24' : 'h-pt-32 h-pb-32'}>
      <Space direction={isMobile ? 'vertical' : 'horizontal'} size={isMobile && 16} align="center">
        <Space direction="vertical" size={16} className={styles.text}>
          <Heading level={1} className={cn(isMobile && 'h-text-center')}>
            Партнерская программа Сравни
          </Heading>
          <Text size={isMobile ? 14 : 20} className={cn(isMobile && 'h-text-center', 'h-color-D60')}>
            Станьте нашим партнером и зарабатывайте на лучших офферах финансовых и страховых продуктов
          </Text>
        </Space>
        <Image
          className={styles.img}
          alt="head-img"
          {...headImg}
          width={isMobile ? 243 : headImg.width / 2}
          height={isMobile ? 203 : headImg.height / 2}
          priority
        />
      </Space>
      {isMobile && (
        <Link href={SignUpRoute.SignUp} onClick={onRegisterClick}>
          <Button size={60} variant="primary" block>
            Зарегистрироваться
          </Button>
        </Link>
      )}
    </Space>
  );
};
